<template>
  <div class="service-details-wrap ptb-100">
    <div class="container">
      <div class="row">
        <div
          class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1 mx-auto"
        >
        <div class="service-desc">
  <h2>Lentes seguridad negros moderno</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/lentes-seguridad-negros-moderno.jpg"
    alt="Lentes seguridad negros moderno"
  />
  <p>
    Lentes de seguridad de diseño moderno con estructura robusta y cómoda. Su material resistente protege contra impactos y polvo, brindando una excelente cobertura para trabajos industriales exigentes.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i>Alta resistencia al impacto.
    </li>
    <li>
      <i class="ri-check-double-line"></i>Diseño ergonómico para mayor comodidad.
    </li>
  </ul>
</div>

<div class="service-desc">
  <h2>Lentes seguridad transparente naranja</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/lentes-seguridad-transparente-naranja.jpg"
    alt="Lentes seguridad transparente naranja"
  />
  <p>
    Lentes de seguridad con una estructura transparente y detalles en naranja. Su diseño liviano proporciona gran visibilidad y confort durante largos períodos de uso.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i>Visibilidad clara y sin distorsiones.
    </li>
    <li>
      <i class="ri-check-double-line"></i>Perfectos para entornos luminosos y con poca visibilidad.
    </li>
  </ul>
</div>

<div class="service-desc">
  <h2>Lentes seguridad negros estilo clasico</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/lentes-seguridad-negros-estilo-clasico.jpg"
    alt="Lentes seguridad negros estilo clasico"
  />
  <p>
    Lentes de seguridad con un estilo clásico, ideales para trabajos que requieren protección contra chispas y objetos voladores. Su diseño compacto y moderno garantiza seguridad y estilo.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i>Alta durabilidad y resistencia.
    </li>
    <li>
      <i class="ri-check-double-line"></i>Protección completa contra impactos.
    </li>
  </ul>
</div>

<div class="service-desc">
  <h2>Lentes seguridad grises transparentes</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/lentes-seguridad-grises-transparentes.jpg"
    alt="Lentes seguridad grises transparentes"
  />
  <p>
    Lentes transparentes de seguridad con un tono gris, ideales para entornos con alta luminosidad. Su diseño permite una cobertura amplia sin comprometer la visión.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i>Diseño anti-deslizante para mayor seguridad.
    </li>
    <li>
      <i class="ri-check-double-line"></i>Resistencia avanzada a impactos.
    </li>
  </ul>
</div>

<div class="service-desc">
  <h2>Lentes seguridad deportivos grises</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/lentes-seguridad-deportivos-grises.jpg"
    alt="Lentes seguridad deportivos grises"
  />
  <p>
    Lentes deportivos de seguridad con un diseño gris aerodinámico, perfectos para trabajos en condiciones extremas donde se necesita mayor protección y confort.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i>Diseño deportivo con ajuste cómodo.
    </li>
    <li>
      <i class="ri-check-double-line"></i>Protección ocular superior contra partículas.
    </li>
  </ul>
</div>

<div class="service-desc">
  <h2>Goggles protección industrial básicos</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/goggles-proteccion-industrial-basicos.jpg"
    alt="Goggles protección industrial básicos"
  />
  <p>
    Goggles básicos para protección industrial, ofreciendo una barrera completa contra polvo y objetos voladores. Su ajuste flexible se adapta a diversas formas de rostro.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i>Protección total para los ojos en entornos industriales.
    </li>
    <li>
      <i class="ri-check-double-line"></i>Ligereza y comodidad durante el uso prolongado.
    </li>
  </ul>
</div>

<div class="service-desc">
  <h2>Goggles protección ajuste negro</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/goggles-proteccion-ajuste-negro.jpg"
    alt="Goggles protección ajuste negro"
  />
  <p>
    Goggles de protección con ajuste negro, ideales para trabajos en áreas donde se requieren altos estándares de seguridad ocular. Su diseño de alta cobertura protege completamente los ojos.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i>Diseño ajustable para máxima comodidad.
    </li>
    <li>
      <i class="ri-check-double-line"></i>Alta protección contra el polvo y escombros.
    </li>
  </ul>
</div>

<div class="service-desc">
  <h2>Goggles protección ajuste gris</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/goggles-proteccion-ajuste-gris.jpg"
    alt="Goggles protección ajuste gris"
  />
  <p>
    Goggles con ajuste gris de alta protección, diseñados para brindar seguridad en ambientes de trabajo de alto riesgo. Su ajuste personalizado asegura una excelente protección.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i>Perfectos para trabajos de alta exposición a riesgos.
    </li>
    <li>
      <i class="ri-check-double-line"></i>Ajuste ergonómico que evita deslizamientos.
    </li>
  </ul>
</div>

<div class="service-desc">
  <h2>Lentes seguridad negros minimalistas</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/lentes-seguridad-negros-minimalistas.jpg"
    alt="Lentes seguridad negros minimalistas"
  />
  <p>
    Lentes de seguridad negros con diseño minimalista, ideales para aquellos que buscan protección sin comprometer el estilo. Su estructura ligera asegura comodidad y durabilidad.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i>Diseño minimalista y ligero.
    </li>
    <li>
      <i class="ri-check-double-line"></i>Perfectos para un uso prolongado sin incomodidad.
    </li>
  </ul>
</div>


<div class="service-desc">
  <h2>Gafas de Seguridad Transparentes Protección Lateral</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/gafas-de-seguridad-transparentes-proteccion-lateral.jpg"
    alt="Gafas de Seguridad Transparentes Protección Lateral"
  />
  <p>
    Las gafas de seguridad transparentes con protección lateral ofrecen un diseño ergonómico y resistente, ideal para ambientes industriales y tareas donde la seguridad visual es primordial. Su diseño envolvente protege contra partículas y salpicaduras.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i>Protección lateral para mayor seguridad.
    </li>
    <li>
      <i class="ri-check-double-line"></i>Material transparente para una visibilidad clara.
    </li>
  </ul>
</div>

<div class="service-desc">
  <h2>Gafas de Seguridad Grises con Protección Solar</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/gafas-de-seguridad-grises-con-proteccion-solar.jpg"
    alt="Gafas de Seguridad Grises con Protección Solar"
  />
  <p>
    Estas gafas ofrecen protección UV y están diseñadas para trabajos al aire libre, combinando seguridad y comodidad. Su tinte gris reduce el deslumbramiento, permitiendo una visión clara bajo la luz del sol.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i>Protección UV ideal para exteriores.
    </li>
    <li>
      <i class="ri-check-double-line"></i>Diseño ligero y cómodo para uso prolongado.
    </li>
  </ul>
</div>

<div class="service-desc">
  <h2>Gafas Negras Envolventes Seguridad Industrial</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/gafas-negras-envolventes-seguridad-industrial.jpg"
    alt="Gafas Negras Envolventes Seguridad Industrial"
  />
  <p>
    Las gafas negras envolventes están diseñadas para máxima cobertura y protección en entornos industriales. Su estructura robusta garantiza resistencia al impacto, mientras que su diseño envolvente asegura la seguridad lateral.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i>Protección lateral y frontal contra impactos.
    </li>
    <li>
      <i class="ri-check-double-line"></i>Material resistente y duradero.
    </li>
  </ul>
</div>

<div class="service-desc">
  <h2>Accesorios de Cordones Ajustables para Gafas</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/accesorios-de-cordones-ajustables-para-gafas.jpg"
    alt="Accesorios de Cordones Ajustables para Gafas"
  />
  <p>
    Los cordones ajustables son el complemento perfecto para gafas de seguridad. Ofrecen un ajuste seguro y cómodo, evitando que las gafas se pierdan o caigan durante el trabajo.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i>Disponible en varios colores.
    </li>
    <li>
      <i class="ri-check-double-line"></i>Ajuste ergonómico para mayor comodidad.
    </li>
  </ul>
</div>

<div class="service-desc">
  <h2>Gafas Transparentes Diseño Ergonómico</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/gafas-transparentes-diseno-ergonomico.jpg"
    alt="Gafas Transparentes Diseño Ergonómico"
  />
  <p>
    Estas gafas transparentes combinan un diseño ergonómico con materiales ligeros, garantizando comodidad y seguridad en el lugar de trabajo. Perfectas para tareas prolongadas.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i>Diseño ergonómico para uso continuo.
    </li>
    <li>
      <i class="ri-check-double-line"></i>Materiales ligeros y resistentes.
    </li>
  </ul>
</div>

<div class="service-desc">
  <h2>Gafas Oscuras Seguridad Diseño Moderno</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/gafas-oscuras-seguridad-diseno-moderno.jpg"
    alt="Gafas Oscuras Seguridad Diseño Moderno"
  />
  <p>
    Con un diseño moderno y funcional, estas gafas oscuras protegen contra el deslumbramiento y partículas. Son ideales para actividades al aire libre y en entornos de alta luminosidad.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i>Protección ocular contra el deslumbramiento.
    </li>
    <li>
      <i class="ri-check-double-line"></i>Estilo moderno y funcional.
    </li>
  </ul>
</div>

<div class="service-desc">
  <h2>Gafas de Protección Negra Marco Ancho</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/gafas-de-proteccion-negra-marco-ancho.jpg"
    alt="Gafas de Protección Negra Marco Ancho"
  />
  <p>
    Estas gafas negras de marco ancho combinan estilo y protección. Su diseño amplio garantiza cobertura total y confort para largas jornadas laborales.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i>Diseño de marco ancho para mayor cobertura.
    </li>
    <li>
      <i class="ri-check-double-line"></i>Estilo profesional y moderno.
    </li>
  </ul>
</div>



<div class="service-desc">
  <h2>Lentes de Seguridad Metálicos Transparentes</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/lentes-seguridad-metalicos-transparentes.jpg"
    alt="Lentes de Seguridad Metálicos Transparentes"
  />
  <p>
    Protección ocular con diseño metálico de alta resistencia. Ideal para
    ambientes industriales que requieren un estilo profesional y seguro.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i> Diseñados para máxima
      resistencia y comodidad.
    </li>
    <li>
      <i class="ri-check-double-line"></i> Lentes transparentes para
      visibilidad óptima.
    </li>
  </ul>
</div>

<div class="service-desc">
  <h2>Lentes de Seguridad Gris Transparente Moderno</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/lentes-seguridad-gris-transparente-moderno.jpg"
    alt="Lentes de Seguridad Gris Transparente Moderno"
  />
  <p>
    Gafas de seguridad modernas con diseño ergonómico. Perfectas para
    trabajos que requieren protección ligera y estilo.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i> Lentes transparentes de alta
      calidad.
    </li>
    <li>
      <i class="ri-check-double-line"></i> Marco gris resistente con
      estilo moderno.
    </li>
  </ul>
</div>

<div class="service-desc">
  <h2>Dispensador de Lentes de Seguridad Transparente</h2>
  <img
    src="../../assets/images/lentes-de-seguridad/dispensador-lentes-seguridad-transparente.jpg"
    alt="Dispensador de Lentes de Seguridad Transparente"
  />
  <p>
    Práctico dispensador para almacenar y distribuir lentes de seguridad
    de forma higiénica y organizada.
  </p>
  <ul class="content-feature-list style5 list-style">
    <li>
      <i class="ri-check-double-line"></i> Hecho de material transparente
      resistente.
    </li>
    <li>
      <i class="ri-check-double-line"></i> Ideal para estaciones de trabajo
      compartidas.
    </li>
  </ul>
</div>

          

        </div>
      </div>
    </div>
  </div>

  <div class="popup-video" v-if="isPopup">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="popup-overlay-close" v-on:click="isPopupMethod(isPopup)">
            <div class="popup-overlay-close-line"></div>
            <div class="popup-overlay-close-line"></div>
          </div>

          <div class="play-video">
            <iframe
              class="responsive-iframe"
              src="https://www.youtube.com/embed/DublqkOSBBA"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  data: () => ({
    isPopup: false,
  }),
  methods: {
    isPopupMethod(isPopup) {
      return (this.isPopup = !isPopup);
    },
  },
};
</script>